(function () {
  // Guard against double-initialization (e.g. theme editor re-render, bfcache,
  // or any accidental duplicate script include).
  if (window.__PV_COOKIE_BANNER_INIT__) {
    return;
  }
  window.__PV_COOKIE_BANNER_INIT__ = true;

  var STORAGE_KEY = 'proventus_cookie_consent_recorded';
  var PENDING_SYNC_KEY = 'proventus_cookie_consent_pending_sync';

  // Defensive cleanup: if more than one banner/modal instance exists in the
  // DOM for any reason, keep only the first and remove the rest so at most
  // one is ever visible.
  function dedupe(id) {
    var nodes = document.querySelectorAll('#' + id);
    for (var i = 1; i < nodes.length; i++) {
      nodes[i].parentNode.removeChild(nodes[i]);
    }
    return nodes[0] || null;
  }

  var banner = dedupe('proventus-cookie-banner');
  var modal = dedupe('proventus-cookie-modal');
  if (!banner || !modal) return;

  var acceptBtn = banner.querySelector('[data-proventus-cookie-accept]');
  var rejectBtn = banner.querySelector('[data-proventus-cookie-reject]');
  var manageBtn = banner.querySelector('[data-proventus-cookie-manage]');
  var saveBtn = modal.querySelector('[data-proventus-cookie-save]');
  var modalCloseTargets = modal.querySelectorAll('[data-proventus-cookie-modal-close]');

  var analyticsToggle = document.getElementById('proventus-cookie-pref-analytics');
  var marketingToggle = document.getElementById('proventus-cookie-pref-marketing');

  var lastFocusedElement = null;

  function safeGet(key) {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function safeSet(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (e) {
      // Storage unavailable (e.g. private browsing) - state won't persist
      // across reloads, but the current session still behaves correctly.
    }
  }

  function safeRemove(key) {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      // ignore
    }
  }

  function hasRecordedConsent() {
    return safeGet(STORAGE_KEY) === '1';
  }

  function markConsentRecorded() {
    safeSet(STORAGE_KEY, '1');
  }

  function showBanner() {
    banner.hidden = false;
  }

  function hideBanner() {
    banner.hidden = true;
  }

  function getFocusableElements(container) {
    return Array.prototype.slice.call(
      container.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (el) {
      return !el.disabled && el.offsetParent !== null;
    });
  }

  function openModal() {
    lastFocusedElement = document.activeElement;
    modal.hidden = false;
    var focusable = getFocusableElements(modal);
    if (focusable.length) {
      focusable[0].focus();
    }
    document.addEventListener('keydown', onModalKeydown, true);
  }

  function closeModal() {
    modal.hidden = true;
    document.removeEventListener('keydown', onModalKeydown, true);
    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus();
    }
  }

  function onModalKeydown(event) {
    if (modal.hidden) return;

    if (event.key === 'Escape') {
      // ESC closes the preferences modal only. It never dismisses the main
      // consent banner - a choice must still be made via Accept/Decline/Save.
      event.preventDefault();
      closeModal();
      return;
    }

    if (event.key === 'Tab') {
      var focusable = getFocusableElements(modal);
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  function trySyncConsent(consent, onSynced) {
    if (
      window.Shopify &&
      window.Shopify.customerPrivacy &&
      typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function'
    ) {
      // Records consent through Shopify's own Customer Privacy API, so any
      // Shopify-consent-aware app (e.g. the Facebook & Instagram channel app)
      // sees the same choice. This banner does not load or call fbq/gtag/GTM.
      window.Shopify.customerPrivacy.setTrackingConsent(consent, function () {
        safeRemove(PENDING_SYNC_KEY);
        if (onSynced) onSynced();
      });
      return true;
    }
    return false;
  }

  function applyConsent(consent) {
    // Hide the banner and record the visitor's choice immediately, regardless
    // of whether the Shopify Customer Privacy API is ready yet. This is what
    // guarantees the banner never gets stuck open due to a slow/unavailable API.
    markConsentRecorded();
    hideBanner();
    closeModal();

    var synced = trySyncConsent(consent);
    if (!synced) {
      // API not ready yet - store the choice and retry once it becomes
      // available (see retrySyncLoop below), instead of silently dropping it.
      safeSet(PENDING_SYNC_KEY, JSON.stringify(consent));
    }
  }

  function acceptAll() {
    applyConsent({
      analytics: true,
      marketing: true,
      preferences: true,
      sale_of_data: true,
    });
  }

  function rejectNonEssential() {
    applyConsent({
      analytics: false,
      marketing: false,
      preferences: false,
      sale_of_data: false,
    });
  }

  function saveCustomPreferences() {
    var marketingAllowed = !!(marketingToggle && marketingToggle.checked);

    applyConsent({
      analytics: !!(analyticsToggle && analyticsToggle.checked),
      marketing: marketingAllowed,
      // This UI only exposes Απαραίτητα / Στατιστικά / Marketing toggles.
      // "preferences" and "sale_of_data" have no dedicated toggle, so they
      // mirror the marketing choice, which is the common mapping when a
      // consent flag isn't surfaced separately in the UI.
      preferences: marketingAllowed,
      sale_of_data: marketingAllowed,
    });
  }

  if (acceptBtn) acceptBtn.addEventListener('click', acceptAll);
  if (rejectBtn) rejectBtn.addEventListener('click', rejectNonEssential);
  if (manageBtn) manageBtn.addEventListener('click', openModal);
  if (saveBtn) saveBtn.addEventListener('click', saveCustomPreferences);
  modalCloseTargets.forEach(function (el) {
    el.addEventListener('click', closeModal);
  });

  // If a consent choice was recorded locally but never made it to Shopify's
  // API (e.g. it loaded after the visitor clicked), keep retrying quietly in
  // the background for this and future page loads until it succeeds.
  function retrySyncLoop() {
    var pending = safeGet(PENDING_SYNC_KEY);
    if (!pending) return;

    var consent;
    try {
      consent = JSON.parse(pending);
    } catch (e) {
      safeRemove(PENDING_SYNC_KEY);
      return;
    }

    var attempts = 0;
    var maxAttempts = 50; // ~10s at 200ms
    var interval = setInterval(function () {
      attempts++;
      if (trySyncConsent(consent) || attempts >= maxAttempts) {
        clearInterval(interval);
      }
    }, 200);
  }

  function init() {
    // Never block showing the banner on the Customer Privacy API being ready.
    // Show it (unless already answered) immediately, then attempt to load the
    // consent-tracking-api in the background purely for syncing choices.
    if (!hasRecordedConsent()) {
      showBanner();
    } else {
      retrySyncLoop();
    }

    var attempts = 0;
    var maxAttempts = 50; // ~10s at 200ms
    var waitForShopify = setInterval(function () {
      attempts++;
      var ready = window.Shopify && typeof window.Shopify.loadFeatures === 'function';

      if (ready) {
        clearInterval(waitForShopify);
        window.Shopify.loadFeatures(
          [{ name: 'consent-tracking-api', version: '0.1' }],
          function () {
            // Whether this succeeds or fails, retry any pending sync now that
            // we've at least attempted to load the API.
            retrySyncLoop();
          }
        );
      } else if (attempts >= maxAttempts) {
        clearInterval(waitForShopify);
      }
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
